import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IHistoryService = ( createDecorator('historyService'));
export { IHistoryService };
